import React, { useState } from 'react';

function MainSidebar({ setCurrentPage, loggedIn }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [activePage, setActivePage] = useState('Home'); // Track active page

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handlePageChange = (page) => {
    setActivePage(page); // Set the clicked page as active
    setCurrentPage(page); // Change the page in parent component
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        <i className="bi bi-list"></i>
      </button>
      <button
        onClick={() => handlePageChange('Home')}
        className={`sidebar-button ${activePage === 'Home' ? 'active' : ''}`}
      >
        <i className="bi bi-speedometer2"></i>
        {!isCollapsed && <span>Home</span>}
      </button>
      {!loggedIn && (
        <>
          <button
            onClick={() => handlePageChange('Solutions')}
            className={`sidebar-button ${activePage === 'Solutions' ? 'active' : ''}`}
          >
            <i className="bi bi-briefcase"></i>
            {!isCollapsed && <span>Solutions</span>}
          </button>
          <button
            onClick={() => handlePageChange('ContactUs')}
            className={`sidebar-button ${activePage === 'ContactUs' ? 'active' : ''}`}
          >
            <i className="bi bi-telephone"></i>
            {!isCollapsed && <span>Contact Us</span>}
          </button>
        </>
      )}
    </div>
  );
}

export default MainSidebar;
